import { HTTP } from "../../../../services/api-service.js";
import commonObj from "../../../../services/common.js";
var common = new commonObj();
var baseUrl = common.baseURL;

//接口里用的名称(对应 COO.Model.DB.ShopLines / ShopLoc 的模型名)
//物理表分别是 CB_ShopLine / CB_ShopLoc，但 /qgl/listvalue 走的是同名视图，
//和 Currency、District、Warehouse 那些 store 的写法一致
var tableShopLine = "ShopLines";
var tableShopLoc = "ShopLoc";
var tableEntityLoc = "EntityLoc";

function buildQuery(table, orderBy) {
  return {
    tableNeedQuery: table,
    isOuterJoin: false,
    searchCriteria: "",
    orderBy: orderBy,
    take: 1000000,
    skip: 0
  };
}

function filterAlive(response) {
  const data = response.data.Data;
  if (data && Array.isArray(data.Data)) {
    data.Data = data.Data.filter(item => !item.RecDel);
    data.Total = data.Data.length;
  }
  return response;
}

const shopsStore = {
  namespaced: true,
  state: {
    totalItem: 0
  },
  actions: {
    //门店线(父级)
    getShopLineList({ commit }) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/qgl/listvalue", buildQuery(tableShopLine, "ShopLine,asc"))
          .then(response => resolve(filterAlive(response)))
          .catch(e => reject(e));
      });
    },
    //门店(子级)
    getShopLocList({ commit }) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/qgl/listvalue", buildQuery(tableShopLoc, "ShopNum,asc"))
          .then(response => resolve(filterAlive(response)))
          .catch(e => reject(e));
      });
    },
    //实体地址(一次取全量，前端按 EntNum 过滤，不要每次都请求)
    getEntityLocList({ commit }) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/qgl/listvalue",
          buildQuery(tableEntityLoc, "EntityLocation,asc")
        )
          .then(response => resolve(filterAlive(response)))
          .catch(e => reject(e));
      });
    },
    //保存门店(option: 0 新增 / 1 修改删除；item2: 1 新增 / 2 修改 / 3 删除)
    saveShopLoc({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/mm/save",
          JSON.stringify({
            type: tableShopLoc,
            modelList: param.modelList,
            option: param.option
          })
        )
          .then(response => resolve(response))
          .catch(e => reject(e));
      });
    },
    //保存门店线
    saveShopLine({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/mm/save",
          JSON.stringify({
            type: tableShopLine,
            modelList: param.modelList,
            option: param.option
          })
        )
          .then(response => resolve(response))
          .catch(e => reject(e));
      });
    }
  }
};

export default shopsStore;
